import React, { useState } from "react";

const LibroReclamaciones = () => {
  const [form, setForm] = useState({
    tipo: "",
    nombre: "",
    documento: "",
    correo: "",
    telefono: "",
    descripcion: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Reclamo enviado correctamente. Nos contactaremos contigo.");
    setForm({
      tipo: "",
      nombre: "",
      documento: "",
      correo: "",
      telefono: "",
      descripcion: ""
    });
  };

  return (
    <div className="container my-5">
      <h1 className="text-center fw-bold mb-4">📕 Libro de Reclamaciones</h1>

      {/* Datos de la empresa */}
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <h5 className="fw-bold">Datos del proveedor</h5>
          <p className="mb-1"><strong>Razón Social:</strong> MARKETLUZ S.A.C.</p>
          <p className="mb-1"><strong>RUC:</strong> 10098478545</p>
          <p className="mb-1"><strong>Dirección:</strong> Lima, Perú</p>
          <p className="mb-1"><strong>Correo:</strong> contacto@marketluz.com</p>
          <p className="mb-0"><strong>Teléfono:</strong> +51 987157652</p>
        </div>
      </div>

      {/* Formulario */}
      <form className="card shadow-sm p-4" onSubmit={handleSubmit}>
        <h5 className="fw-bold mb-3">Detalle del reclamo</h5>

        <div className="mb-3">
          <label className="form-label">Tipo</label>
          <select
            className="form-select"
            name="tipo"
            value={form.tipo}
            onChange={handleChange}
            required
          >
            <option value="">Seleccione</option>
            <option value="Reclamo">Reclamo</option>
            <option value="Queja">Queja</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Nombre completo</label>
          <input
            type="text"
            className="form-control"
            name="nombre"
            value={form.nombre}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">DNI / CE</label>
          <input
            type="text"
            className="form-control"
            name="documento"
            value={form.documento}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Correo electrónico</label>
          <input
            type="email"
            className="form-control"
            name="correo"
            value={form.correo}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Teléfono</label>
          <input
            type="text"
            className="form-control"
            name="telefono"
            value={form.telefono}
            onChange={handleChange}
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Detalle del reclamo</label>
          <textarea
            className="form-control"
            rows="4"
            name="descripcion"
            value={form.descripcion}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <button className="btn btn-danger w-100 fw-semibold">
          Enviar reclamo
        </button>
      </form>

      <p className="text-muted small mt-3">
        Conforme al Código de Protección y Defensa del Consumidor – INDECOPI.
      </p>
    </div>
  );
};

export default LibroReclamaciones;
